/**
 * @fileoverview
 * Loader Component - Reusable loading overlay with spinner
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css',
})
export class LoaderComponent {
  @Input() message: string = 'Processing...';
  @Input() show: boolean = false;
}
